import React from 'react'
import Shimmer from 'Components/shimmer'
import Image from 'next/image'

const BeautyFiles = ({ beautyFiles }) => (
  <React.Fragment>
    { beautyFiles.is_loading && beautyFiles?.data?.length <= 0 ? (
      <div className="sidebar-content">
        <div className="row-shimmer">
          {[...Array(5).keys()].map((index) => (
            <Shimmer key={String(index)} id="1" height="130px" width="100%" />
          ))}
        </div>
      </div>
    ) : Array.isArray(beautyFiles?.data) &&
      beautyFiles?.data?.length > 0 ? (
      <div className="sidebar-content">
        <div className="sidebar-title-wrapper">
          <h3 className="sidebar-content-title">Beauty Files</h3>
        </div>
        {beautyFiles.data.slice(0, 5).map((item, idx) => (
          <a
            href={`${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/blog/tag/${item.slug}`}
            key={idx}
          >
            <Image
              src={item.image}
              alt={item.image}
              layout="fixed"
              objectFit="cover"
              width={240}
              height={150}
              quality={90}
            />
          </a>
        ))}
      </div>
    ) : null}
  </React.Fragment>
)

export default BeautyFiles
